import React, { useMemo } from "react";
import { mainMenu } from "../../../../../app/MainMenu";
import { useHtmlClassService } from "../../../_core/MetronicLayout";
import { AsideMenuList } from "./AsideMenuList";
import "./custom.scss";

export function AsideMenu({ isActive, activeMenu }) {
   const uiService = useHtmlClassService();
   const layoutProps = useMemo(() => {
      return {
         layoutConfig: uiService.config,
         asideMenuAttr: uiService.getAttributes("aside_menu"),
         ulClasses: uiService.getClasses("aside_menu_nav", true),
         asideClassesFromConfig: uiService.getClasses("aside_menu", true)
      };
   }, [uiService]);
   // function handleToggleAside() {
   //    const toggleBtn = document.getElementById("kt_aside_mobile_toggle");
   //    if (toggleBtn) {
   //       toggleBtn.click();
   //    }
   // }
   return (
      <>
         {/* <div className="custom-toggle">
            <button className="btn p-0 burger-icon burger-icon-left" onClick={handleToggleAside}>
               <span />
            </button>
         </div> */}

         <div className={`tab-pane fade show active`}>
            <div className="aside-menu-wrapper flex-column-fluid py-5">
               {/* begin::Menu Container */}
               <div
                  id="kt_aside_menu"
                  data-menu-vertical="1"
                  className={`aside-menu p-5 ${layoutProps.asideClassesFromConfig}`}
                  {...layoutProps.asideMenuAttr}
               >
                  <div className="wrapper">
                     {mainMenu?.layout?.map((item, i) => {
                        return (
                           <>
                              {item?.children
                                 ?.filter((x) => x.id === activeMenu)
                                 .map((menuItem) => {
                                    return (
                                       <AsideMenuList
                                          key={menuItem.id}
                                          api={menuItem.api}
                                          kind={menuItem.kind}
                                          data={[]}
                                          layoutProps={layoutProps}
                                          activeMenu={activeMenu}
                                       />
                                    );
                                 })
                              }
                           </>
                        );
                     })}
                  </div>
               </div>
               {/* end::Menu Container */}
            </div>
         </div>
      </>
   );
}
